import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// import { useTheme } from 'styled-components';
import techniciansJobApi from '../../APIs/technicians';
import {
  Button,
  PageHeader,
  Pagination,
  Table,
  Tag,
  Typography,
} from '../../designComponents';
import { TableDataType } from '../../designComponents/Table';
import { VIEW_BROWSE_JOBS_ROUTE } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { PaginationType } from '../../types';
import { humanReadableDate, requestAPI } from '../../utils';
import { BrowseJobsMainContainer } from './style';

type ParamsType = {
  page: number;
  limit: number;
};

type MyParamsType = PaginationType & { search?: string };

export type JobsType = {
  _id: string;
  jobTitle: string;
  buildingName: string;
  status: string;
  createdBy: {
    fullName: string;
    avatar: string;
  };
  building: {
    buildingName: string;
    buildingAddress: string;
    notes: string;
  };
  createdAt: string;
};
const BrowseJobs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const pagination = useSelector(
    (state: RootState) => state.technicianAllJobs.pagination,
  );
  const jobs: JobsType[] = useSelector(
    (state: RootState) => state.technicianAllJobs.data,
  );
  const handleTechnicianAllJobs = async (myParams: MyParamsType) => {
    try {
      await requestAPI(
        techniciansJobApi.getTechnicianAllJobs({
          page: myParams.page,
          limit: myParams.limit,
          status: 'ACTIVE',
          ...(myParams?.search ? { search: myParams.search } : {}),
        }),
      );
    } catch (error) {
      console.log(error);
    }
  };

  const delayedSearch = useCallback(
    (params: MyParamsType) => {
      debounce(() => handleTechnicianAllJobs(params), 500)();
    },
    [search],
  );
  useEffect(() => {
    handleTechnicianAllJobs(pagination);
  }, []);
  const tableData: TableDataType = {
    headings: [
      { key: 'date', label: 'Date' },
      { key: 'clientName', label: 'Client Name' },
      // {
      //   key: 'clientRole',
      //   label: 'Client Role',
      // },
      { key: 'jobTitle', label: 'Job Title' },

      {
        key: 'buildingName',
        label: 'Building Name',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'actions',
        label: 'Actions',
      },
    ],
    body: Array.isArray(jobs)
      ? jobs?.map((job) => {
        return {
          id: job._id,
          // date: '12 aug 2023 - 12:59 am',
          date: humanReadableDate(job.createdAt),
          clientName: job.createdBy.fullName,

          jobTitle: job.jobTitle,
          buildingName: job.building.buildingName,
          status: <Tag type="success">{job?.status}</Tag>,
          actions: (
              <Button
                variant="secondary"
                onClick={() => {
                  navigate(VIEW_BROWSE_JOBS_ROUTE.replace(':jobId', job._id));
                }}
                style={{
                  backgroundColor: theme.colors.blueLight,
                  border: `1px solid ${theme.colors.blueLight}`,
                }}
              >
                View Details
              </Button>
          ),
        };
      })
      : [],
  };

  const handlePagination = (updatedParams: ParamsType) => {
    handleTechnicianAllJobs(updatedParams);
    dispatch(
      Store.Actions.update('technicianAllJobs.pagination', {
        ...pagination,
        ...updatedParams,
      }),
    );
  };

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    delayedSearch({ ...pagination, page: 1, search: value });
  };

  return (
    <BrowseJobsMainContainer>
      <PageHeader
        pageTitle={<Typography variant="title">Browse Jobs</Typography>}
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />
      <div className="table-container">
        <Table tableData={tableData} maxWidthForCardView="800px" />
      </div>
      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination.totalData || 0}
      />
    </BrowseJobsMainContainer>
  );
};

export default BrowseJobs;
